var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useMutation, useLazyQuery } from '@apollo/client';
import { useSnackbar } from 'notistack';
import get from 'lodash/get';
import { useDrawer } from 'context/DrawerContext';
import sharedMessages from 'translations/shared';
import { track, SegmentTrackableEnum } from 'factory/SegmentFactory';
import getLocationQuery from './query.graphql';
import updateLocationMutation from './mutation.graphql';
import View from './View';
var Container = function (_a) {
    var onError = _a.onError, onSuccess = _a.onSuccess, locationId = _a.locationId;
    var closeDrawer = useDrawer().closeDrawer;
    var formatMessage = useIntl().formatMessage;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _b = __read(useLazyQuery(getLocationQuery), 2), getLocation = _b[0], getResult = _b[1];
    var _c = __read(useMutation(updateLocationMutation, {
        onCompleted: function (data) {
            if (onSuccess)
                onSuccess(data.updateLocation);
            track(SegmentTrackableEnum.LOCATION_EDITED, __assign({}, data));
            enqueueSnackbar(formatMessage(sharedMessages.updatedLocation), {
                variant: 'success',
            });
            closeDrawer();
        },
        onError: function (error) {
            enqueueSnackbar(error.message, {
                variant: 'error',
            });
            if (onError)
                onError(error);
        },
    }), 2), updateLocation = _c[0], updateResult = _c[1];
    useEffect(function () {
        getLocation({
            variables: {
                input: {
                    id: locationId,
                },
            },
        });
    }, []);
    var onUpdate = function (input) {
        updateLocation({
            variables: {
                input: input,
            },
        });
    };
    return (_jsx(View, { onUpdate: onUpdate, isLoading: getResult.loading, isProcessing: updateResult.loading, error: updateResult.error || getResult.error, location: get(getResult, 'data.getAddressById') }, void 0));
};
export default Container;
